export enum DoorHandleType {
  euro2015 = 'Euro2015',
  euro2000 = 'Euro2000',
  euro2016 = 'Euro2016',
  null = 'None',
}
